import {
  CreateNotificationRequest,
  DeleteNotificationRequest,
  GetNotificationRequest,
  NotificationsRequest,
  UpdateNotificationRequest,
} from '../api/requests';
import type { UserStore } from '~/authentication/stores/user';
import type ApiClient from '~/common/services/ApiClient';
import type { RequestPagination } from '~/common/types';
import { NotificationRequest } from '../types';

export class NotificationService {
  apiClient: ApiClient;
  userStore: UserStore;

  constructor(apiClient: ApiClient, userStore: UserStore) {
    this.apiClient = apiClient;
    this.userStore = userStore;
  }

  async fetch(pagination: RequestPagination, params: Record<string, any>) {
    const accessToken = this.userStore.accessToken;
    const request = new NotificationsRequest({
      token: accessToken,
      params: { ...pagination, ...params },
    });

    return this.apiClient.request(request);
  }

  async get(notificationId: string, params?: { include: string }) {
    const accessToken = this.userStore.accessToken;
    const request = new GetNotificationRequest({
      token: accessToken,
      notificationId,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }

  async create(notification: NotificationRequest) {
    const accessToken = this.userStore.accessToken;
    const request = new CreateNotificationRequest({
      token: accessToken,
      notification,
    });

    return this.apiClient.request(request);
  }

  async update(notificationId: string, notification: NotificationRequest) {
    const accessToken = this.userStore.accessToken;
    const request = new UpdateNotificationRequest({
      token: accessToken,
      notificationId,
      notification,
    });

    return this.apiClient.request(request);
  }

  async delete(notificationId: string) {
    const accessToken = this.userStore.accessToken;
    const request = new DeleteNotificationRequest({
      token: accessToken,
      notificationId,
    });

    return this.apiClient.request(request);
  }
}
